import { createFileRoute } from '@tanstack/react-router';
import { OrganizationSecurityPage } from '@/features/organization/security/security-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/security')({
    staticData: { crumbs: [{ label: 'settings.nav.security' }] },
    component: function OrganizationSecurityRoute() {
        const { organizationId } = Route.useParams();
        return <OrganizationSecurityPage organizationId={organizationId} />;
    },
});
